
import { useParams } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useCharacterBySlug } from "@/hooks/useCharacterBySlug";
import { useDocumentHead } from "@/hooks/useDocumentHead";
import { CharacterDetailLoading } from "@/components/characters/CharacterDetailLoading";
import { CharacterDetailError } from "@/components/characters/CharacterDetailError";
import { CharacterDetailContent } from "@/components/characters/CharacterDetailContent";

const CharacterDetail = () => {
  const { characterSlug } = useParams<{ characterSlug: string }>();
  const { data: character, isLoading, error } = useCharacterBySlug(characterSlug);

  // Set up SEO and document head
  useDocumentHead({
    title: character ? `${character.name} - Bobo & Teedee® Character` : "Loading Character - Bobo & Teedee®",
    description: character 
      ? `Meet ${character.name}, ${character.species ? `a ${character.species}` : 'a character'} from Bobo & Teedee®. ${character.description || `Learn about ${character.name}'s adventures in the Cayman Islands.`}`
      : "Loading character information from Bobo & Teedee®",
    keywords: character 
      ? `${character.name}, Bobo Teedee, Cayman Islands, educational cartoon, children's show, ${character.species}, ${character.role}`.replace(/undefined,?\s*/g, '').replace(/,\s*$/, '')
      : "Bobo Teedee, Cayman Islands, educational cartoon, children's show"
  });

  if (error) {
    return <CharacterDetailError />;
  }

  if (isLoading) {
    return <CharacterDetailLoading />;
  }

  if (!character) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-blue/10 to-teedee-blue/10">
      <Navbar />
      <CharacterDetailContent character={character} />
      <Footer />
    </div>
  );
};

export default CharacterDetail;
